import React,{useState} from 'react'
import './Login.css'
import axios from 'axios';
import {useNavigate, Link} from "react-router-dom"
import loadingGif from '../../Resources/loading2.gif'
import Navbar from '../Navbar/Navbar';
import BASE_URL from '../../constant';


export default function Login({setUserLoginState}) {


  const [errmsg, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  let msgStyle = {
    display : errmsg ? "flex" : "none"
  }

  const navigate = useNavigate();
  const [user, setUser] = useState({
      email : "",
      password : "",
  });
  const handleChange = e =>{
      const {name, value} = e.target;
      setUser({
          ...user,
          [name] : value
      })
  }
  const handleSubmit = (e)=>{
    e.preventDefault();
    setLoading(true)
    setTimeout(() => {
      setErrorMessage('');
    }, 5000);
    if(!user.email){
      setErrorMessage("Please provide an email account");
      setLoading(false);
      return;
    }else if(!user.password){
      setErrorMessage("Please enter a password");
      setLoading(false)
      return;
    }
    if(user.email === "admin7408@gmail.com" && user.password === "admin7408"){
      
      axios.post(`${BASE_URL}/bookmyshow/api/v1/auth/login`,user)
      .then(res => {
          localStorage.setItem("adminData", JSON.stringify({
            adminId : res.data.userId,
            adminName : res.data.username,
            adminToken : res.data.token
          }))
          setLoading(false)
          navigate("/admin");
      })
      .catch(err => {
        setErrorMessage(err.response.data.message)
        setLoading(false)
      })
      return;
    }
    axios.post(`${BASE_URL}/bookmyshow/api/v1/auth/login`,user)
    .then(res => {
        console.log(res.data);
        localStorage.setItem("userData", JSON.stringify({
          userId : res.data.userId,
          username : res.data.username,
          email : res.data.email,
          phone : res.data.phone,
          usertoken : res.data.token
        }))
        setLoading(false)
        navigate("/");
    })
    .catch(err => {
      setErrorMessage(err.response.data.message)
      setLoading(false)
    })
  }

  return (
    <>
    <Navbar />
  <div className='authContainer'>
    <div className="logalertmsg" style={msgStyle} >
      <span className="msgtext" >
      <i className="fa-solid fa-circle-exclamation"></i> &nbsp; &nbsp; {
          errmsg
        }
      </span>
      <span className="close-btn" onClick={()=>{setErrorMessage('')}}>×</span>
      <span className="line"></span>
    </div>
    <form method="post" className='form loginForm'>
        <div className="heading">Login</div>
        <div className="input-field">
          <label htmlFor="email"><i className="fa-regular fa-envelope"></i>&nbsp; Email</label>
          <input type="email" name="email" id="email" value={user.email} onChange={handleChange}/>
        </div>
        <div className="input-field">
          <label htmlFor="password"><i className="fa-solid fa-key"></i>&nbsp; Password</label>
          <input type="password" name="password" id="password" value={user.password} onChange={handleChange} />
        </div>
        {
          (loading) ? 
          <button className='submitBtn loadsubmitBtn' type="submit">
            <img src={loadingGif} alt="" /> Logging you in...
          </button>
           : 
          <button className='submitBtn' type="submit" onClick={handleSubmit}>Submit</button>
        }
        <div className="regLink">
          New here ?  &nbsp;
          <span className="changeLink">
            <Link to='/register' >Create account</Link>
          </span>
        </div>
    </form>
    </div>
    </>
  )
}
